export const AUTH_NAMESPACE = 'auth'
export const AUTH_REQUEST = 'authRequest'
export const REMEMBER_REQUEST = 'rememberRequest'
export const SET_STATUS = 'setStatus'
export const REMEMBER_OPERATION_ID = 'rememberOperationId'
export const REMEMBER_OPERATION_ID_RESET = 'rememberOperationIdReset'
export const REMEMBER_OPERATION_TIME = 'rememberOperationTime'
export const REMEMBER_CODE_ATTEMPTS = 'rememberCodeAttempts'
export const REMEMBER_CODE_REQUEST = 'rememberCodeRequest'
export const REMEMBER_NEW_PASSWORD_REQUEST = 'rememberNewPasswordRequest'
export const AUTH_STATUS_RESET = 'authStatusReset'
export const AUTH_REQUEST_LOADING = 'authRequestLoading'
export const AUTH_SUCCESS = 'authSuccess'
export const AUTH_ERROR = 'authError'
export const AUTH_STATUS_ERROR = 'authStatusError'
export const AUTH_LOGOUT = 'authLogout'
export const AUTH_AUTHENTICATED = 'isAuthenticated'
export const AUTH_STATUS = 'authStatus'
export const AUTH_FIRST_CHECK_LOGGED = 'authFirstCheckLogged'
export const AUTH_REALM_LOGIN = 'realmLogin'
export const DOUBLE_FACTOR_OPERATION_ID = 'doubleFactorOperationId'
export const DOUBLE_FACTOR_OPERATION_ID_RESET = 'doubleFactorOperationIdReset'
export const DOUBLE_FACTOR_OPERATION_TIME = 'doubleFactorOperationTime'
export const DOUBLE_FACTOR_CODE_ATTEMPTS = 'doubleFactorCodeAttempts'
export const DOUBLE_FACTOR_CODE_REQUEST = 'doubleFactorCodeRequest'
